import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiClient from '../../Api/apiClient';
import AnimationCheckoutPage from '../../Assets/images/checkoutImage.png';
import LocationInpc from '../../Components/Location/LocationInpc';
import Swal from 'sweetalert2';
import UserCheckoutAlert from '../../Components/Alert/UserCheckoutAlert';
const PayForm = ({ onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    packageId,
    amount,
    duration,
    save,
    name,
    regular_amount,
    discount_amount,
    discount_percent,
  } = location.state || {};

  // console.log(
  //   'pricing values:',
  //   packageId,
  //   amount,
  //   duration,
  //   save,
  //   name,
  //   regular_amount,
  //   discount_amount,
  //   discount_percent
  // );


  // const [countryCode, setCountryCode] = useState('88');
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    mobile: '',
    district_id: null,
    upazila_id: null,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [selectedLocation, setSelectedLocation] = useState({
    districtId: null,
    districtName: '',
    upazilaId: null,
    upazilaName: '',
  });

  // Handle location selection
  const handleLocationSelect = (
    districtId,
    districtName,
    upazilaId,
    upazilaName
  ) => {
    setSelectedLocation({ districtId, districtName, upazilaId, upazilaName });
    setFormData(prev => ({
      ...prev,
      district_id: districtId,
      upazila_id: upazilaId,
    }));
  };

  // Fetch Profile Data and Auto-Fill Form
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await apiClient.get('/user/profile');
        // console.log('Profile Data:', response.data.data);

        const { full_name, email, phone, district, upazila } =
          response.data.data;

        setFormData(prev => ({
          ...prev,
          full_name,
          email,
          phone,
          district_id: response.data.data.district_id || null,
          upazila_id: response.data.data.upazila_id || null,
        }));

        setSelectedLocation({
          districtId: response.data.data.district_id || null,
          districtName: district || '', // Set district as a string
          upazilaId: response.data.data.upazila_id || null,
          upazilaName: upazila || '', // Set upazila as a string
        });
      } catch (error) {

        console.error('Error fetching profile data:', error);
        // if (error.response && error.response.status === 401) {
        //   console.log('Unauthorized, redirecting to login...');
        //   onLogout();
        //   navigate('/login');
        // } else {
        //   console.error('Error fetching profile data:', error);
        //   const errorMessage = error.response?.data?.message;
        //   Swal.fire({
        //     title: 'Error',
        //     text: errorMessage,
        //     confirmButtonText: 'Okay',
        //     customClass: {
        //       popup: 'w-72 h-auto p-3',
        //       title: 'text-lg',
        //       content: 'text-xs',
        //       confirmButton:
        //         'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
        //     },
        //   });
        // }
      }
    };

    fetchProfileData();
  }, [onLogout, navigate]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { full_name, email, phone } = formData;
    const payload = {
      package_id: packageId,
      full_name,
      email,
      // phone : countryCode + phone,
       phone :phone,
      district_id: selectedLocation.districtId,
      upazila_id: selectedLocation.upazilaId,
    };

    
     console.log('Sending Data:', payload);

    try {
      const response = await apiClient.post('/user/payment/initiate', payload);
      const { checkout_url } = response.data;
      if (checkout_url) {
        window.location.href = checkout_url;
      } else {
        setError('Failed to retrieve checkout URL.');
      }
    } catch (err) {
      // setError('Failed to initiate payment. Please try again.');
      const errorMessage = err.response.data.message;
      //  setError(errorMessage);
      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Okay',
        customClass: {
          popup: 'w-96 h-auto p-3',
          title: 'text-sm',
          content: 'text-xs',
          confirmButton:
            'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
        },
      });

    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center pt-20 pb-10 container mx-auto mt-20 md:mt-24 2xl:mt-32">
        <div className="bg-white shadow-lg border rounded-md p-8 max-w-5xl w-full">
          <UserCheckoutAlert />
          <div className="flex flex-col md:flex-row gap-6 mt-6">
            {/* Order Summary Section */}
            <div className="md:w-1/2 w-full">
              <h2 className="text-xl font-semibold mb-4">Order Summary</h2>
              <ul className="space-y-2">
                <li className="flex justify-between">
                  <span>Package Name</span> <span>{name}</span>
                </li>
                <li className="flex justify-between">
                  <span>Duration</span> <span>{duration} Months</span>
                </li>
                <li className="flex justify-between">
                  <span>Regular Amount</span> <span>৳ {regular_amount}</span>
                </li>
                <li className="flex justify-between">
                  <span>Discount {discount_percent}%</span>
                  <span>৳ {discount_amount || 0}</span>
                </li>
                <li className="flex justify-between border-b">
                  <span></span>
                </li>
                <li className="flex justify-between">
                  <span>Total</span> <span>৳ {amount}</span>
                </li>
              </ul>
            </div>
            <div className="border-r md:block hidden">
              <span></span>
            </div>

            {/* Checkout Section */}
            <div className="md:w-1/2 w-full">
              <h2 className="text-xl font-semibold mb-4">Check Out</h2>
              <form onSubmit={handleSubmit}>
                <div className="space-y-4">
                  <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
                    <label className="md:w-1/3 w-full font-medium">Name*</label>
                    <input
                      type="text"
                      name="full_name"
                      value={formData.full_name}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-md px-4 py-2"
                      required
                    />
                  </div>

                  <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
                    <label className="md:w-1/3 w-full font-medium">
                      Email*
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-md px-4 py-2"
                      required
                    />
                  </div>

                  <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
                    <label className="md:w-1/3 w-full font-medium">
                      Phone*
                    </label>

                    {/* <div className="w-full md:w-full flex space-x-1">
                      <select
                        className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24 "
                        value={countryCode}
                        onChange={e => setCountryCode(e.target.value)}
                      >
                        <option value="88">+88(Ban)</option>
                        <option value="1">+1(USA/Canada)</option>
                        <option value="44">+44(UK)</option>
                        <option value="91">+91(India)</option>
                        <option value="61">+61(Aust)</option>
                        <option value="33">+33(France)</option>
                        <option value="49">+49(Germany)</option>
                        <option value="39">+39(Italy)</option>
                        <option value="81">+81(Japan)</option>
                        <option value="7">+7(Russia)</option>
                        <option value="86">+86(China)</option>
                        <option value="34">+34(Spain)</option>
                        <option value="55">+55(Brazil)</option>
                        <option value="27">+27(SA)</option>
                        <option value="52">+52(Mexico)</option>
                        <option value="20">+20(Egypt)</option>
                        <option value="45">+45(Denmark)</option>
                        <option value="31">+31(Netherlands)</option>
                        <option value="90">+90(Turkey)</option>
                        <option value="63">+63(Philippines)</option>
                        <option value="66">+66(Thailand)</option>
                        <option value="32">+32(Belgium)</option>
                        <option value="56">+56(Chile)</option>
                        <option value="46">+46(Sweden)</option>
                        <option value="351">+351(Portugal)</option>
                        <option value="965">+965(Kuwait)</option>
                        <option value="971">+971(UAE)</option>
                        <option value="30">+30(Greece)</option>
                        <option value="972">+972(Israel)</option>
                        <option value="964">+964(Iraq)</option>
                        <option value="256">+256(Uganda)</option>
                      </select>
                      <input

                        name="phone"
                        type="tel"

                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md px-4 py-2"
                        required
                      />
                    </div> */}

                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-md px-4 py-2"
                      required
                    />
                  </div>

                  {/* Location Input */}
                  <LocationInpc
                    onSelectLocation={handleLocationSelect}
                    selectedLocation={selectedLocation}
                  />
                </div>

                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="mt-6 md:w-1/3 w-full bg-orange-500 text-white font-medium py-2 rounded-md hover:bg-orange-600"
                    disabled={loading}
                  >
                    {loading ? 'Processing...' : 'Pay Now'}
                  </button>
                </div>
              </form>
              {error && <p className="text-red-500 mt-4">{error}</p>}
            </div>
          </div>
        </div>

        {/* Illustration Section */}
        <div className="mt-8">
          <img
            src={AnimationCheckoutPage}
            alt="Payment Illustration"
            className="w-full h-40 max-w-md mx-auto"
          />
        </div>
      </div>
    </>
  );
};

export default PayForm;

// import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import apiClient from '../../Api/apiClient';
// // import AnimationCheckoutPage from '../../Assets/gif/AnimationCheckoutPage.gif'
// import AnimationCheckoutPage from '../../Assets/images/checkoutImage.png';
// import LocationSelector from '../../Components/Location/Location';
// import LocationInpc from '../../Components/Location/LocationInpc';
// const PayForm = () => {
//   const location = useLocation();
//   // const packageId = location.state?.packageId || '';
//   const {
//     packageId,
//     amount,
//     duration,
//     save,
//     name,
//     regular_amount,
//     discount_amount,
//     discount_percent,
//   } = location.state || {};

//   console.log(
//     'Navigating with package details in payform page:',
//     regular_amount,
//     packageId,
//     amount,
//     duration,
//     save,
//     name,
//     discount_percent,
//     discount_amount
//   );

//   const [selectedLocation, setSelectedLocation] = useState({
//     districtId: null,
//     districtName: '',
//     upazilaId: null,
//     upazilaName: '',
//   });

//   // Callback function to receive data from LocationSelector
//   const handleLocationSelect = (
//     districtId,
//     districtName,
//     upazilaId,
//     upazilaName
//   ) => {
//     setSelectedLocation({ districtId, districtName, upazilaId, upazilaName });
//   };

//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     district_id: null,
//     upazila_id: null,
//   });

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   // Handle input change
//   const handleChange = e => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     const { name, email, city, address } = formData;

//     const payload = {
//       package_id: packageId,
//       name,
//       email,
//       district_id: selectedLocation.districtId,
//       upazila_id: selectedLocation.upazilaId,
//     };

//     console.log("before send data:",payload)

//     try {
//       const response = await apiClient.post('/user/payment/initiate', {
//         package_id: packageId,
//         name,
//         email,
//         district_id: selectedLocation.districtId,
//         upazila_id: selectedLocation.upazilaId,
//       });

//       const { checkout_url } = response.data;
//       if (checkout_url) {
//         window.location.href = checkout_url;
//       } else {
//         setError('Failed to retrieve checkout URL.');
//       }
//     } catch (err) {
//       setError('Failed to initiate payment. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="flex flex-col md:text-sm text-xs items-center justify-center pt-20 pb-10 container mx-auto mt-20 md:mt-24 2xl:mt-32">
//         <div className="bg-white shadow-lg border rounded-md p-8 max-w-5xl w-full">
//           <div className="flex flex-col md:flex-row gap-6">
//             {/* Order Summary Section */}
//             <div className="md:w-1/2 w-full">
//               <h2 className="text-xl font-semibold mb-4">Order Summary</h2>
//               <ul className="space-y-2">
//                 <li className="flex justify-between">
//                   <span>Package Name</span> <span>{name}</span>
//                 </li>
//                 <li className="flex justify-between">
//                   <span>Duration</span> <span>{duration} Months</span>
//                 </li>
//                 <li className="flex justify-between">
//                   <span>Regular Amount</span> <span>৳ {regular_amount}</span>
//                 </li>
//                 <li className="flex justify-between">
//                   <span>Discount {discount_percent}%</span>{' '}
//                   <span>৳ {discount_amount}</span>
//                 </li>
//     <li className="flex justify-between border-b">
//       <span></span>
//     </li>
//     <li className="flex justify-between">
//       <span>Total</span> <span>৳ {amount}</span>
//     </li>
//   </ul>
// </div>
// <div className="border-r md:block hidden">
//   <span></span>
// </div>
//             {/* Checkout Section */}
//             <div className="md:w-1/2 w-full">
//               <h2 className="text-xl font-semibold mb-4">Check Out</h2>
//
//               <form onSubmit={handleSubmit}>
//                 <div className="space-y-4">
//                   {/* <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     placeholder="Name"
//                     className="w-full border  rounded-md px-4 py-2"
//                     required
//                   />
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="Email"
//                     className="w-full border  rounded-md px-4 py-2"
//                     required
//                   /> */}
//                   <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
//                     <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
//                       Name*
//                     </label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       placeholder="Enter your name"
//                       className="w-full border border-gray-300 rounded-md px-4 py-2"
//                       required
//                     />
//                   </div>
//                   <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
//                     <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
//                       Email*
//                     </label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       placeholder="Enter your email"
//                       className="w-full border border-gray-300 rounded-md px-4 py-2"
//                       required
//                     />
//                   </div>
//                   <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
//                     <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
//                       Phone*
//                     </label>
//                     <input
//                       type="text"
//                       name="mobile"
//                       value={formData.mobile}
//                       onChange={handleChange}
//                       placeholder="Enter Phone with country code"
//                       className="w-full border border-gray-300 rounded-md px-4 py-2"
//                       required
//                     />
//                   </div>
//                   <LocationInpc onSelectLocation={handleLocationSelect} />
//                 </div>
//                 <div className="flex justify-end">
//                   <button
//                     type="submit"
//                     className="mt-6 md:w-1/3 w-full bg-orange-500 text-white font-medium py-2 rounded-md hover:bg-orange-600"
//                     disabled={loading}
//                   >
//                     {loading ? 'Processing...' : 'Pay Now'}
//                   </button>
//                 </div>
//               </form>
//               {error && <p className="text-red-500 mt-4">{error}</p>}
//             </div>
//           </div>
//         </div>

//         {/* Illustration Section */}
//         <div className="mt-8">
//           <img
//             src={AnimationCheckoutPage}
//             alt="Payment Illustration"
//             className="w-full h-40 max-w-md mx-auto"
//           />
//         </div>
//       </div>

//     </>
//   );
// };

// export default PayForm;

// import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import apiClient from '../../Api/apiClient';

// const PayForm = () => {
//   const location = useLocation();
//   const packageId = location.state?.packageId || '';

//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     city: '',
//     address: '',
//   });

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [successMessage, setSuccessMessage] = useState('');

//   // Handle input change
//   const handleChange = e => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//  const handleSubmit = async e => {
//    e.preventDefault();
//    setLoading(true);
//    setError('');
//    setSuccessMessage('');

//    const { name, email, city, address } = formData;

//    console.log(name, email, city, address);

//    try {
//      const response = await apiClient.post('/user/payment/initiate', {
//        package_id: packageId,
//        name,
//        email,
//        address,
//        city,
//      });

//      const { checkout_url } = response.data;
//      if (checkout_url) {
//        // Redirect user to the checkout URL
//        window.location.href = checkout_url;
//      } else {
//        setError('Failed to retrieve checkout URL.');
//      }

//      setSuccessMessage('Payment initiated successfully!');
//      console.log('Response:', response.data);
//    } catch (err) {
//      setError('Failed to initiate payment. Please try again.');
//      console.error('Error:', err);
//    } finally {
//      setLoading(false);
//    }
//  };

//   return (
//     <div className="pt-20 flex flex-col items-center py-10 container mx-auto md:mt-24 2xl:mt-32">
//       <div className="background shadow-lg border rounded-md p-8 max-w-2xl w-full">
//         <h1 className="md:text-3xl text-2xl font-semibold text-center mb-6">
//           Payment Checkout Form
//         </h1>
//         <form onSubmit={handleSubmit}>
//           <div className="flex flex-col md:flex-row justify-between items-start gap-2 mb-6">
//             <label className="font-medium text-gray-700 w-full md:w-1/5">
//               Name<span className="text-red-500">*</span>:
//             </label>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               placeholder="Enter Name"
//               className="w-full border border-gray-300 rounded-md px-3 py-2 md:w-4/5"
//               required
//             />
//           </div>

//           <div className="flex flex-col md:flex-row justify-between items-start gap-2 mb-6">
//             <label className="font-medium text-gray-700 w-full md:w-1/5">
//               Email<span className="text-red-500">*</span>:
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               placeholder="Enter Email"
//               className="w-full border border-gray-300 rounded-md px-3 py-2 md:w-4/5"
//               required
//             />
//           </div>

//           <div className="flex flex-col md:flex-row justify-between items-start gap-2 mb-6">
//             <label className="font-medium text-gray-700 w-full md:w-1/5">
//               City<span className="text-red-500">*</span>:
//             </label>
//             <input
//               type="text"
//               name="city"
//               value={formData.city}
//               onChange={handleChange}
//               placeholder="Enter City"
//               className="w-full border border-gray-300 rounded-md px-3 py-2 md:w-4/5"
//               required
//             />
//           </div>

//           <div className="flex flex-col md:flex-row justify-between items-start gap-2 mb-6">
//             <label className="font-medium text-gray-700 w-full md:w-1/5">
//               Address<span className="text-red-500">*</span>:
//             </label>
//             <textarea
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//               placeholder="Enter Address"
//               className="w-full border border-gray-300 rounded-md px-3 py-2 md:w-4/5 h-24"
//               required
//             />
//           </div>

//           {/* Buttons */}
//           <div className="flex justify-center gap-4 mt-8">
//             <button
//               type="button"
//               className="px-6 py-2 bg-gray-200 text-gray-700 font-medium rounded-full hover:bg-gray-300"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="px-6 py-2 bg-DefaultColor text-white font-medium rounded-full hover:bg-DefaultHoverColor"
//               disabled={loading}
//             >
//               {loading ? 'Processing...' : 'Pay Now'}
//             </button>
//           </div>

//           {/* Messages */}
//           {error && <p className="text-red-500 mt-4">{error}</p>}

//         </form>
//       </div>
//     </div>
//   );
// };

// export default PayForm;

//   //  {
//   //    successMessage && <p className="text-green-500 mt-4">{successMessage}</p>;
//   //  }
